import { Suspense } from 'react';
import { useRoutes } from 'react-router';
import { SignaSessionProvider } from './lib/SignaSessionContext';
import { ToastProvider } from './components/ui/Toast';
import { SkeletonList } from './components/ui/Skeleton';
import { PageContainer } from './components/ui/Card';
import { ROUTES } from './routes';

// Raíz de la app. Sólo cablea: sesión → avisos → rutas. La lógica vive en los módulos que monta.
//
// El `<Suspense>` es la contracara del `lazy()` de `routes.tsx`: mientras baja el bundle de una
// ruta hay que mostrar ALGO con la estética del producto. Un flash en blanco entre pantallas es
// justamente el «panel sin explicación» que la regla de los tres estados prohíbe.

function RouteFallback() {
  return (
    <PageContainer>
      <SkeletonList rows={3} label="Cargando la pantalla" />
    </PageContainer>
  );
}

function RoutedApp() {
  return useRoutes(ROUTES);
}

export function App() {
  return (
    <SignaSessionProvider>
      <ToastProvider>
        <Suspense fallback={<RouteFallback />}>
          <RoutedApp />
        </Suspense>
      </ToastProvider>
    </SignaSessionProvider>
  );
}

export default App;
